<template>
  <div>
    <dl class="mb10" v-for="(info, index) in value" :key="info.key">
      <dd class="colorBox familyBox">
        <div>
          {{ info.incluNm }}
          <span v-if="info.incluBirthMonDate">({{ info.incluBirthMonDate }})</span>
        </div>
        <div class="tit_btnbox">
          <a class="btn_color" @click="() => select(info)">선택</a>
        </div>
      </dd>
    </dl>
    <dl v-if="value.length < 1">
      <dd class="colorBox familyBox">
        등록된 가족 정보가 없습니다.
        <br />
        가족 정보는 홈페이지 > 마이페이지 > 가족정보 에서 입력 가능합니다.
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  props: ['value', 'select'],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.familyBox {
  display: flex;
  align-items: center;
  justify-content: space-between;

  & .tit_btnbox {
    position: relative;
  }
}
</style>
